<template>
  <div class="ResourceDetail el-col-24">
    <div class="tableTitle">
      <a href="javascript:;" @click="back()"
        ><i class="icon el-icon-arrow-left"></i>&nbsp;返回</a
      >

      <div @click="ppClassList" class="pipeiBtn">点击匹配到课程</div>
      <el-button
        @click="deleteClass"
        type="danger"
        size="small"
        style="float: right; margin-top: 25px;margin-right: 25px; "
        >删除该上课资源</el-button
      >
    </div>
    <div class="tableTitle">
      <i class="icon icon-shu"></i>课中回顾资源
    </div>
    <div class="videoList el-col-23">
      <div class="card-carousel-wrapper">
        <div
          class="card-carousel--nav__left"
          @click="moveCarousel(-1)"
          :disabled="atHeadOfList"
        ></div>
        <div class="card-carousel">
          <div class="card-carousel--overflow-container">
            <div
              class="card-carousel-cards"
              :style="{
                transform: 'translateX' + '(' + currentOffset + 'px' + ')'
              }"
            >
              <div
                class="card-carousel--card"
                @click="imgPopShow(i)"
                :key="i"
                v-for="(item, i) in lessonImages"
              >
                <img :src="item.ResourcesPath" />
                <div class="card-carousel--card--footer">
                  <a
                    class="p"
                    @click.stop="delFile2(item.ResourcesID, i, 'lessonImages')"
                    ><i class="el-icon-close"></i
                  ></a>
                  <a
                    class="p"
                    @click.stop=""
                    target="_blank"
                    :href="item.ResourcesPath"
                    ><i class="el-icon-download"></i
                  ></a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="card-carousel--nav__right"
          @click="moveCarousel(1)"
          :disabled="atEndOfList"
        ></div>
      </div>
    </div>
    <!--    微课录制-->
    <div class="tableTitle el-col-23">
      <i class="icon icon-shu"></i>微课录制
    </div>
    <div class="videoList el-col-23">
      <div
        v-for="(item, index) in videoList"
        @mouseover="item.bool = true"
        @mouseout="item.bool = false"
        :key="index"
        class="videoBox el-col-7 el-col-offset-1"
      >
        <el-input
          @focus="focusName = item.ResourcesName"
          @blur="ChangeName(item.ResourcesID, item.ResourcesName)"
          v-model="item.ResourcesName"
          class="videoTitle"
          placeholder="请输入微课标题"
        ></el-input>
        <video :src="item.ResourcesPath" class="videoCover"></video>
        <div class="videoBtnS">
          <div
            :class="{ videoBtnC: item.bool }"
            @click="downFile(item.ResourcesPath)"
            class="videoBtn"
          >
            下载
          </div>
          <div
            :class="{ videoBtnC: item.bool }"
            @click="delFile(item.ResourcesID)"
            class="videoBtn"
          >
            删除
          </div>
        </div>
        <i @click="playVideo(item)" class="icon el-icon-video-play"></i>
      </div>
    </div>
    <!--    直播回放-->
    <div class="tableTitle el-col-23">
      <i class="icon icon-shu"></i>直播回放
    </div>
    <div class="videoList el-col-23">
      <div
        v-for="(item, index) in liveList"
        :key="index"
        @mouseover="item.bool = true"
        @mouseout="item.bool = false"
        class="videoBox el-col-7 el-col-offset-1"
      >
        <el-input
          @focus="focusName = item.ResourcesName"
          @blur="ChangeName(item.ResourcesID, item.ResourcesName)"
          v-model="item.ResourcesName"
          class="videoTitle"
          placeholder="请输入微课标题"
        ></el-input>
        <video :src="item.ResourcesPath" class="videoCover"></video>
        <div class="videoBtnS">
          <div
            :class="{ videoBtnC: item.bool }"
            @click="downFile(item.ResourcesPath)"
            class="videoBtn"
          >
            下载
          </div>
          <div
            :class="{ videoBtnC: item.bool }"
            @click="delFile(item.ResourcesID)"
            class="videoBtn"
          >
            删除
          </div>
        </div>
        <i @click="playVideo(item)" class="icon el-icon-video-play"></i>
      </div>
    </div>
    <!--    弹出video-->
    <div v-if="Cover.show" class="CoverBox el-col-16">
      <div class="title">{{ Cover.ResourcesName }}</div>
      <!--最新的修改-->
      <div class="videops">
        <video
          class="videoCover"
          :id="'videoCover' + Cover.ResourcesID"
          v-if="
            Cover.ResourcesPath.substring(Cover.ResourcesPath.length - 3) ==
              'flv'
          "
        ></video>
        <video
          v-else
          :id="'videoCover' + Cover.ResourcesID"
          class="video-js videoCover"
          controls
          preload="auto"
          data-setup="{}"
        >
          <!--<source :src="Cover.ResourcesPath" type="video/mp4">-->
          <source
            v-if="
              Cover.ResourcesPath.substring(Cover.ResourcesPath.length - 3) ==
                '3u8'
            "
            :src="Cover.ResourcesPath"
            type="application/x-mpegURL"
          />
          <source
            v-if="
              Cover.ResourcesPath.substring(Cover.ResourcesPath.length - 3) ==
                'mp4'
            "
            :src="Cover.ResourcesPath"
            type="video/mp4"
          />
        </video>
      </div>
      <!--最新的修改-->
      <div class="setBen">
        <div
          @click="downFile(Cover.ResourcesPath)"
          class="el-col-8 CoverDown CoverBtn"
        >
          下载
        </div>
        <div
          @click="delFile(Cover.ResourcesID)"
          class="el-col-8 CoverDel CoverBtn"
        >
          删除
        </div>
        <div @click="closeVideo(Cover)" class="el-col-8 CoverClose CoverBtn">
          关闭
        </div>
      </div>
    </div>
    <!--      匹配课程-->
    <el-dialog
      class="tk_pp"
      title="匹配课程"
      :visible.sync="ppkc"
      width="50%"
      overflow="hidden"
      padding="0"
      left
    >
      <div class="tk_top">课程名称 <span>下课时间</span></div>
      <div class="radioList">
        <div v-for="item in radioArr" class="radioBox">
          <el-radio v-model="radio" :label="item.TeachingPlanID">{{
            item.CourseTitle
          }}</el-radio>
          <div class="el-time">{{ item.CreateDate }}</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="ppkc = false">取 消</el-button>
        <el-button type="primary" @click="ppClick">确 定</el-button>
      </span>
    </el-dialog>

    <div
      v-if="lessonImgDialog"
      class="lessonImgDialog"
      @click="lessonImgDialog = false"
    >
      <div class="lessonImgCarousel">
        <el-carousel
          :initial-index="carouselIndex"
          :autoplay="false"
          arrow="always"
          height="720px"
        >
          <el-carousel-item v-for="(item, i) in lessonImages" :key="i">
            <img style="height:720px;" :src="item.ResourcesPath" alt="" />
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
  </div>
</template>

<script>
import "video.js/dist/video-js.min.css";
import "videojs-flash/dist/videojs-flash";
import videojs from "video.js";
import flvjs from "flv.js";
export default {
  name: "ResourceDetail",
  data() {
    return {
      players: "", //
      fileList: [],
      videoList: [],
      liveList: [],
      PlanClassID: "",
      lessonID: "",
      Cover: {
        //弹框video
        ResourcesName: "",
        ResourcesPath: "",
        show: false,
        ResourcesID: ""
      },
      radioArr: [], //匹配列表
      ppkc: false, //匹配课程弹框
      radio: 1, //匹配课程的id
      focusName: "", //获取焦点的Name
      lessonImages: [],
      lessonImgDialog: false,
      carouselIndex: 0, //显示的图片
      currentOffset: 0,
      paginationFactor: 330
    };
  },
  //   mounted() {
  //     this.PlanClassID = this.$route.query.id;
  //     this.lessonID = this.$route.query.lessonID;
  //     // return;
  //     this.getDetail();
  //     this.getImageListByLessonID(this.lessonID);
  //     // this.getImageListByLessonID(22798)
  // },
  watch: {
    $route(to, from) {
      if (from.name == "ResourceList"  && to.name == "ResourceDetail") {
        this.PlanClassID = this.$route.query.id;
        this.lessonID = this.$route.query.lessonID;
        // return;
        this.getDetail();
        this.getImageListByLessonID(this.lessonID);
      }
    }
  },
  methods: {
    back() {
      this.$router.back();
    },
    getDetail() {
      let that = this;
      this.axios
        .post(window.url + "GetResourcesClass", {
          PlanClassID: that.PlanClassID,
          lessonID: that.lessonID
        })
        .then(res => {
          let data = res.data;
          that.returnCode(data.result, data.message);
          data.data.ResourcesMP4List.forEach(function(item, index) {
            item.ResourcesName = item.ResourcesName.slice(
              0,
              item.ResourcesName.length - 4
            );
            item.ResourcesPath = item.ResourcesPath;
            item.bool = false;
          });
          that.videoList = data.data.ResourcesMP4List;
          //console.log("微课", this.videoList);
          /////////////////////////////////////////////////////
          data.data.ResourcesFLVList.forEach(function(item, index) {
            item.ResourcesName = item.ResourcesName.slice(
              0,
              item.ResourcesName.length - 4
            );
            item.ResourcesPath = item.ResourcesPath;
            item.bool = false;
          });
          that.liveList = data.data.ResourcesFLVList;
          //console.log("直播", this.liveList);
        })
        .catch(error => {
          // that.$message.error('您的网络开小差了！')
        });
    },
    // 失去焦点修改name
    ChangeName(ResourcesID, ResourcesName) {
      let that = this;
      if (that.focusName != ResourcesName) {
        this.axios
          .post(window.url + "UpdateResources", {
            ResourcesID: ResourcesID,
            ResourcesName: ResourcesName
          })
          .then(res => {
            var data = res.data;
            that.returnCode(data.result, data.message);
          })
          .catch(error => {
            // that.$message.error('您的网络开小差了！')
          });
      }
    },
    //删除上课资源
    deleteClass() {
      this.$confirm("确认删除该上课资源吗？", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.axios
            .post(window.url + "DeleteUnmatchedClass", {
              planClassId: this.PlanClassID,
              lessonId: this.lessonID
            })
            .then(res => {
              var data = res.data;
              if (data.result == 200) {
                this.$message.success("删除成功！");
                this.$router.back();
              }
            })
            .catch(error => {
              // that.$message.error('您的网络开小差了！')
            });
        })
        .catch(() => {});
    },
    // 匹配列表
    ppClassList() {
      let that = this;
      this.axios
        .post(window.url + "MatchingPlan", {
          PlanClassID: that.PlanClassID
        })
        .then(res => {
          var data = res.data;
          that.returnCode(data.result, data.message);
          that.ppkc = true;
          that.radioArr = data.data;
        })
        .catch(error => {
          // that.$message.error('您的网络开小差了！')
        });
    },
    // 匹配课程
    ppClick() {
      var that = this;
      this.axios
        .post(window.url + "Matching", {
          PlanClassID: that.PlanClassID,
          TeachingPlanID: that.radio
        })
        .then(res => {
          //console.log(res);
          let data = res.data;
          if (res.data.result !== 200) {
            this.$alert(res.data.message, "提示");
            return;
          }
          that.radio = 1;
          this.$alert(res.data.message, "提示");
          that.ppkc = false;
          this.$router.replace({ name: "ResourceList" });
        })
        .catch(error => {
          // that.$message.error('您的网络开小差了！')
        });
    },
    // 下载文件
    downFile(url) {
      window.open(url);
    },
    // 弹框播放微课
    playVideo(item) {
      this.Cover = {
        ResourcesName: item.ResourcesName,
        ResourcesPath: item.ResourcesPath,
        ResourcesID: item.ResourcesID,
        show: true
      };
      this.$nextTick().then(res => {
        if (
          this.Cover.ResourcesPath.substring(
            this.Cover.ResourcesPath.length - 3
          ) == "flv"
        ) {
          this.Cover.Type = "flv";
          if (flvjs.isSupported()) {
            this.players = document.getElementById(
              "videoCover" + this.Cover.ResourcesID
            );
            let url = this.Cover.ResourcesPath;
            //console.log(url);
            let flvPlayer = flvjs.createPlayer({
              type: "flv",
              url: url
            });
            flvPlayer.attachMediaElement(this.players);
            flvPlayer.load();
            flvPlayer.play();
          }
        } else {
          this.Cover.Type = "mp4";
          this.players = videojs(
            "videoCover" + this.Cover.ResourcesID,
            {},
            function() {
              this.play();
            }
          );
        }
      });
    },
    //关闭视频播放
    closeVideo(co) {
      if (co.Type === "mp4") {
        this.players.dispose();
      } else {
        this.players = null;
      }
      this.Cover = {
        ResourcesName: "",
        ResourcesPath: "",
        ResourcesID: "",
        show: false
      };
    },

    // 删除文件
    delFile(ResourcesID) {
      var that = this;
      this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        closeOnClickModal: false,
        type: "warning"
      })
        .then(() => {
          this.axios
            .post(window.url + "DeleteResources", {
              ResourcesID: ResourcesID
            })
            .then(res => {
              var data = res.data;
              that.returnCode(data.result, data.message);
              this.getDetail();
              that.Cover.show = false;
              that.$message.success(data.message);
            })
            .catch(error => {
              // that.$message.error('您的网络开小差了！')
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    delFile2(ResourcesID, i, tag) {
      //删除备课资源.
      this.$confirm("此操作将会永久性删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.axios
          .post(window.url + "DeleteResources", {
            ResourcesID: ResourcesID
          })
          .then(res => {
            this.$alert(res.data.message, "提示");
            if (res.data.result === 200) {
              switch (tag) {
                case "ResourcesList": //课前备课资源
                  this.prepareLessonsData.ResourcesList.splice(i, 1);
                  break;
                case "lessonImages": //课中图片
                  this.lessonImages.splice(i, 1);
                  break;
                default:
                  this.Cover.show = false;
                  this.getInClassData();
                  break;
              }
            }
          });
      });
    },
    // 返回值调用
    returnCode(code, msg) {
      var that = this;
      if (code != 200) {
        if (code == 201) {
          this.$router.push({ name: "Login" });
        }
        that.$message.error(msg);
        return;
      }
    },
    getImageListByLessonID(lessonID) {
      //获取课中授课的图片
      this.axios
        .get(window.url + `GetImageListByLessonID?lessonID=${lessonID}`)
        .then(res => {
          //console.log("课中图片",res);
          if (res.data.result !== 200) {
            this.$alert(res.data.message, "提示");
            return;
          }
          this.lessonImages = res.data.data;
        });
    },
    moveCarousel(direction) {
      // 课中图片移动.
      if (direction === 1 && !this.atEndOfList) {
        this.currentOffset -= this.paginationFactor;
      } else if (direction === -1 && !this.atHeadOfList) {
        this.currentOffset += this.paginationFactor;
      }
    },
    //图片弹出展示
    imgPopShow(i) {
      this.carouselIndex = i;
      this.lessonImgDialog = true;
    }
  },
  computed: {
    atEndOfList() {
      return (
        this.currentOffset <=
        this.paginationFactor *
          -1 *
          (this.lessonImages.length - this.windowSize)
      );
    },
    atHeadOfList() {
      return this.currentOffset === 0;
    }
  }
};
</script>

<style lang="less" scoped>
.ResourceDetail {
  text-align: left;

  .pipeiBtn {
    float: right;
    height: 32px;
    line-height: 32px;
    width: 120px;
    margin-top: 25px;
    font-size: 14px;
    font-weight: 500;
    text-align: center;
    cursor: pointer;
    color: #ffffff;
    background-color: #3e9af3;
    -webkit-border-radius: 3px;
    -moz-border-radius: 3px;
    border-radius: 3px;
  }

  .tableTitle {
    height: 70px;
    line-height: 70px;
    font-size: 22px;
    text-align: left;

    .icon-shu {
      font-size: 24px;
      background: #59bf85;
      border-radius: 2px;
      width: 5px;
      height: 18px;
      margin: 0px 10px;
      display: inline-block;
    }

    a {
      font-size: 18px;
      text-decoration: none;
    }
    a:-webkit-any-link {
      text-decoration: none;
    }
  }

  .bei_box {
    width: 100%;
    overflow: hidden;
    border: 1px solid #dedede;
    background-color: #ffffff;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;

    .beipipei {
      width: 100px;
      height: 35px;
      margin: 10px auto;
      cursor: pointer;
    }

    .bei_top {
      margin: 0 auto;
      width: 94%;
      text-align: left;

      .file_li {
        height: 40px;
        line-height: 40px;
        border-bottom: 1px dashed #dedede;

        .file_yx {
          display: inline-block;
          vertical-align: top;
          margin-right: 20px;
        }

        .file_icon {
          display: inline;
          background-color: #5f90ff;
          color: #ffffff;
          padding: 2px 4px;
          -webkit-border-radius: 3px;
          -moz-border-radius: 3px;
          border-radius: 3px;
        }

        .file_name {
          margin-right: 60px;
          max-width: 200px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .file_del {
          color: red;
          cursor: pointer;
          padding: 0 6px;
        }

        .file_down {
          color: #00be00;
          cursor: pointer;
          padding: 0 6px;
        }
      }
    }

    .bei_bottom {
      height: 60px;
      background-color: #e5e5e5;

      .btn_file {
        top: 15px;
        left: 30px;
        position: relative;
        cursor: pointer;
        background-color: #ffffff;
        display: block;
        height: 30px;
        line-height: 30px;
        width: 140px;
        text-align: center;
        -webkit-border-radius: 3px;
        -moz-border-radius: 3px;
        border-radius: 3px;
        -webkit-box-shadow: 0 0 1px 2px #dedede;
        -moz-box-shadow: 0 0 1px 2px #dedede;
        box-shadow: 0 0 1px 2px #dedede;

        .fileBtn {
          cursor: pointer;
          position: absolute;
          width: 100%;
          height: 100%;
          left: 0;
          top: 0;
          opacity: 0;
        }
      }

      .add {
        height: 40px;
        width: 40px;
        margin: 60px auto;
      }
    }
  }

  .videoList {
    .videoBox {
      font-size: 15px;
      margin-bottom: 30px;
      position: relative;

      .videoCover {
        width: 100%;
        height: 9vw;
        cursor: pointer;
      }

      .videoBtnS {
        width: 100%;
        height: 36px;
        line-height: 36px;

        .videoBtn {
          width: 50%;
          float: left;
          color: #000;
          cursor: pointer;
          background-color: #ececec;
          text-align: center;
        }

        .videoBtnC:nth-child(1) {
          color: #ffffff;
          background-color: #67b4ff;
        }

        .videoBtnC:nth-child(2) {
          color: #ffffff;
          background-color: #e66262;
        }
      }

      .icon {
        cursor: pointer;
        position: absolute;
        top: 40px;
        left: 0;
        color: #ffffff;
        width: 100%;
        font-size: 40px;
        line-height: 9vw;
        height: 9vw;
        text-align: center;
        background: #000;
      }
    }
  }

  .CoverBox {
    position: fixed;
    text-align: center;
    background-color: #ffffff;
    width: 1100px;
    top: 50px;
    bottom: 50px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 11;
    border: 1px solid #dedede;
    -webkit-border-radius: 10px;
    -moz-border-radius: 10px;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 0 10px 2px #dedede;

    .title {
      font-size: 18px;
      text-indent: 2em;
      line-height: 40px;
      font-weight: 600;
      text-align: left;
      border-bottom: 1px solid #dedede;
    }

    .videops {
      position: absolute;
      left: 0;
      right: 0;
      top: 42px;
      bottom: 50px;
    }
    .videoCover {
      width: 100%;
      height: 100%;
    }
    video[id] {
      width: 100%;
      height: 100%;
    }
    .setBen {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      a {
        text-decoration: none;
      }
    }

    .CoverBtn {
      color: #ffffff;
      font-size: 16px;
      line-height: 50px;
      cursor: pointer;
    }

    .CoverDown {
      background-color: #67b4ff;
      /*background-color: #999999;*/
      border-right: 1px solid #ffffff;
    }

    .CoverDel {
      background-color: #e66262;
      /*background-color: #999999;*/
      border-right: 1px solid #ffffff;
    }

    .CoverClose {
      background-color: #999999;
    }
  }
  .tk_pp {
    .tk_top {
      height: 40px;
      line-height: 40px;
      text-indent: 2em;
      background-color: #eaedf2;

      span {
        width: 40%;
        text-align: left;
        float: right;
      }
    }

    .radioList {
      overflow-y: scroll;
      height: 50vh;
      .radioBox {
        border-bottom: 1px solid #dedede;
        padding: 0 2%;
        line-height: 40px;
        height: 40px;

        .el-radio {
          width: 60%;
          display: inline-block;
          vertical-align: middle;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .el-time {
          width: 30%;
          display: inline-block;
          vertical-align: middle;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }

  //图片弹出
  .lessonImgDialog {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: auto;
    margin: 0;
    z-index: 2006;
    background: rgba(0, 0, 0, 0.3);

    .lessonImgCarousel {
      width: 1280px;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);

      /deep/ .el-carousel {
        .el-carousel__arrow {
          background: rgba(255, 255, 255, 0.6);
          color: #000;
          font-size: 30px;
          font-weight: bold;
        }
      }
    }
  }
}
.card-carousel-wrapper {
  margin: 20px 0;
  height: 180px;
  color: #666a73;
  position: relative;
}

.card-carousel {
  position: absolute;
  left: 50px;
  top: 0;
  right: 50px;
  bottom: 0;
  display: flex;
  justify-content: center;
  flex: 1 1 auto;
}

.card-carousel--overflow-container {
  overflow: hidden;
}

.card-carousel--nav__left,
.card-carousel--nav__right {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  bottom: 0;
  display: inline-block;
  width: 30px;
  height: 30px;
  box-sizing: border-box;
  border-top: 5px solid #42b883;
  border-right: 5px solid #42b883;
  cursor: pointer;
  margin: 0 10px;
  transition: transform 150ms linear;
}

.card-carousel--nav__left {
  left: 0;
}

.card-carousel--nav__right {
  right: 0;
}

.card-carousel--nav__left[disabled],
.card-carousel--nav__right[disabled] {
  opacity: 0.2;
  border-color: black;
}

.card-carousel--nav__left {
  transform: rotate(-135deg);
}

.card-carousel--nav__left:active {
  transform: rotate(-135deg) scale(0.9);
}

.card-carousel--nav__right {
  transform: rotate(45deg);
}

.card-carousel--nav__right:active {
  transform: rotate(45deg) scale(0.9);
}

.card-carousel-cards {
  transition: transform 150ms ease-out;
  transform: translatex(0px);
  /*height: 300px;*/
  white-space: nowrap;
}

.card-carousel-cards .card-carousel--card {
  display: inline-block;
  margin: 0 5px;
  cursor: pointer;
  box-shadow: 0 4px 15px 0 rgba(40, 44, 53, 0.06),
    0 2px 2px 0 rgba(40, 44, 53, 0.08);
  background-color: #fff;
  border-radius: 4px;
  z-index: 3;
  margin-bottom: 2px;
  position: relative;
  width: 320px;
  height: 180px;
  line-height: 180px;
}

.card-carousel-cards .card-carousel--card:first-child {
  margin-left: 0;
}

.card-carousel-cards .card-carousel--card:last-child {
  margin-right: 0;
}

.card-carousel-cards .card-carousel--card img {
  max-width: 320px;
  max-height: 180px;
  vertical-align: bottom;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  transition: opacity 150ms linear;
  user-select: none;
}

.card-carousel-cards .card-carousel--card img:hover {
  opacity: 0.5;
}

.card-carousel-cards .card-carousel--card--footer {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 40px;
  border-top: 0;
  /*padding: 7px 15px;*/
  display: flex;
  justify-content: space-between;
}

.card-carousel-cards .card-carousel--card--footer .p {
  display: block;
  margin: 0;
  margin-bottom: 2px;
  width: 40px;
  height: 40px;
  text-align: center;
  line-height: 43px;
  font-size: 30px;
  font-weight: bold;
  border-radius: 100px;
  color: #fff;
  background: rgba(0, 0, 0, 0.6);
  user-select: none;
}
</style>
<style lang="less">
.el-dialog .el-dialog--center .el-dialog__body {
  padding: 0 !important;
  max-height: 500px;
  overflow-y: scroll;
  overflow-x: hidden;
}
.el-radio__inner {
  border-color: #8a8a8a;
}
</style>



// WEBPACK FOOTER //
// src/components/ResourceDetail.vue